module.exports = __webpack_public_path__ + "img/x-mark.ad6400d9.png";